import {
  TemplateParentTypeEnum,
  WidgetTypeConfig,
} from '@/types';
// V3
// eslint-disable-next-line import/no-cycle
import emailWidgetTextConfig from '@/components/template-builder/config/templates/email/widgets/widget-text-config';
// eslint-disable-next-line import/no-cycle
import displayWidgetTextConfig from '@/components/template-builder/config/templates/display/widgets/widget-text-config';
// eslint-disable-next-line import/no-cycle
import facebookWidgetTextConfig from '@/components/template-builder/config/templates/facebookmessenger/widgets/widget-text-config';
// V4
// eslint-disable-next-line import/no-cycle
import emailWidgetTextConfigV4 from '@/components/template-builder/config/templates/email-v4/widgets/widget-text-config';
// eslint-disable-next-line import/no-cycle
import displayWidgetTextConfigV4 from '@/components/template-builder/config/templates/display-v4/widgets/widget-text-config';

const textConfigV3 = {
  [TemplateParentTypeEnum.FACEBOOKMESSENGER]: facebookWidgetTextConfig,
  [TemplateParentTypeEnum.EMAIL]: emailWidgetTextConfig,
  [TemplateParentTypeEnum.POPUP]: displayWidgetTextConfig,
  [TemplateParentTypeEnum.EMBED]: displayWidgetTextConfig,
  [TemplateParentTypeEnum.TEASER]: displayWidgetTextConfig,
};

const textConfigV4 = {
  [TemplateParentTypeEnum.FACEBOOKMESSENGER]: facebookWidgetTextConfig,
  [TemplateParentTypeEnum.EMAIL]: emailWidgetTextConfigV4,
  [TemplateParentTypeEnum.POPUP]: displayWidgetTextConfigV4,
  [TemplateParentTypeEnum.EMBED]: displayWidgetTextConfigV4,
  [TemplateParentTypeEnum.TEASER]: displayWidgetTextConfigV4,
};

const getWidgetTextConfig = (templateType: string, isV4 = false): WidgetTypeConfig => {
  const config = isV4 ? textConfigV4 : textConfigV3;
  if (
    templateType === TemplateParentTypeEnum.FACEBOOKMESSENGER
    || templateType === TemplateParentTypeEnum.EMAIL
    || templateType === TemplateParentTypeEnum.POPUP
    || templateType === TemplateParentTypeEnum.EMBED
    || templateType === TemplateParentTypeEnum.TEASER
  ) {
    return config[templateType];
  }
  return {};
};

export default getWidgetTextConfig;
